// Weekly rent -> rental bond calculator, shared by the Add Property form and the
// Property Information edit panels on the property detail pages.
//
// Victorian bond = the calendar-month rent, per Consumer Affairs Victoria's rent
// calculator: monthly rent = (365 / 12) x daily rent - NOT weekly rent x 4.
// Commercial leases don't collect a bond (weekly_rent there holds an annual, not
// weekly, figure, so the formula wouldn't apply), so they return "".
export const calculateBond = (weeklyRentValue, propertyClass) => {
  if (propertyClass === "Commercial") return "";
  const weeklyRent = parseFloat(String(weeklyRentValue).replace(/[$,]/g, "")) || 0;
  if (!weeklyRent) return "";
  const dailyRent = weeklyRent / 7;
  const bondAmount = Math.round((dailyRent * 365) / 12);
  return `$${bondAmount.toLocaleString()}`;
};
